// extracted by mini-css-extract-plugin
export default {"imagesWrapper":"styles_imagesWrapper__zBeO7","imageWrapper":"styles_imageWrapper__H31mO","width40":"styles_width40__e-GQ5","cardSection":"styles_cardSection__X0he3"};